import React, { useMemo } from "react";
import { Box, ScrollArea, Title, Text } from "@mantine/core";
import {
  CustomKeyValueSections,
  CustomUnderlineTabs,
  CustomWarningsAccordion,
} from "@components/custom";

import { eventKeyMetricSections } from "@components/data/dataset-key-metrics-data";
import { WarningItem } from "@components/data/dataset-warnings-data";
import { useDatasourceErrors } from "@/src/hooks/useDatasourceErrors";
import { formatTimeWithTooltip } from "@shared/helpers/dates";

import styles from "@scss/custom-components/dataset-side-panel.module.scss";

type CwiggoEventSidePanelProps = {
  variant: "not-live" | "live" | "replaying";
  eventId?: string | number;
};

export const DatasetSidePanel: React.FC<CwiggoEventSidePanelProps> = ({
  variant,
  eventId,
}) => {
  // Fetch datasource errors with live updates
  const { errors, isLoading } = useDatasourceErrors({
    eventId,
    enableLive: true,
  });

  // Transform datasource errors into warning items format
  const warningItems: WarningItem[] = useMemo(() => {
    return errors.map((error) => {
      const { display: timeDisplay } = formatTimeWithTooltip(
        error.createdAt,
        false,
      );

      return {
        id: String(error.id || error.publicId),
        time: timeDisplay,
        title: error.errorTitle || "Unknown Error",
        fields: [
          {
            label: "Description",
            value: error.errorDescription || "No description",
          },
          {
            label: "Athlete",
            value: error.athleteName || String(error.athleteId || "N/A"),
          },
          {
            label: "Datasource ID",
            value: String(error.datasetDatasourceId || "N/A"),
          },
          { label: "Error ID", value: String(error.id) },
        ],
        buttonLabel: "Data Source",
      };
    });
  }, [errors]);
  return (
    <CustomUnderlineTabs
      size="md"
      values={["warnings"]}
      tabs={[
        <>
          <></>
          Warnings
        </>,
      ]}
      panels={[
        /*
        <Box className={styles.tabPanelWrapper}>
          <ScrollArea
            className={styles.tabPanelContainer}
          >
            <Title order={4} my="lg">
              <></>
              &nbsp;Key Metrics
            </Title>
            <CustomKeyValueSections
              sections={eventKeyMetricSections}
              variant={variant}
            />
          </ScrollArea>
        </Box>,
        */
        <Box className={styles.tabPanelWrapper}>
          <ScrollArea className={styles.tabPanelContainer}>
            <Title order={4} my="lg">
              <></>{" "}
              Warnings {isLoading && "(Loading...)"}
            </Title>
            {isLoading ? (
              <Text>Loading warnings...</Text>
            ) : warningItems.length === 0 ? (
              <Text c="dimmed">No warnings found</Text>
            ) : (
              <CustomWarningsAccordion data={warningItems} />
            )}
          </ScrollArea>
        </Box>,
      ]}
    />
  );
};
